// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2QG1T","label":"CategoryService_label__1dcLt","location":"CategoryService_location__1jK5u"};